<template>
    <Container class="tw-animate-pulse">
        <CategoriesWrapper class="tw-sticky tw-top-safe-area-top tw-z-10 tw-mb-4 tw-bg-white tw-py-2">
            <CategoryButton
                v-for="i in filteredCategories.length"
                :key="i"></CategoryButton>
        </CategoriesWrapper>
        <HighlightedPost></HighlightedPost>
        <template
            v-for="i in 4"
            :key="i">
            <PostListItemLoader></PostListItemLoader>
            <v-divider
                v-if="i < 4"
                class="tw-my-5"
                opacity="0.1"></v-divider>
        </template>
    </Container>
</template>

<script setup lang="ts">
    import HighlightedPost from '@/components/loaders/news/HighlightedPostLoader.vue';
    import CategoryButton from '@/components/loaders/news/CategoryButtonLoader.vue';
    import PostListItemLoader from '@/components/loaders/news/PostListItemLoader.vue';
    import categories from '@/configs/categories';

    const filteredCategories = categories.filter((category) => category.showInNews);
</script>

<style scoped></style>
